import Vue from 'vue'

import routes from './routes'
import { addRoutes } from '@simpl/core/plugins/router'

export default function register (_: typeof Vue, app: Vue) {
  addRoutes(routes)
}
